import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { DiscussionCreateRequest, DiscussionModel, DiscussionTodoStats } from '../models/discussion.models';
import { PatchDiscussionDto } from '../models/dto/patch-discussion.dto';
import { SaveDiscussionFormDto } from '../models/dto/save-discussion-form.dto';

@Injectable({ providedIn: 'root' })
export class DiscussionApiService {
  private http = inject(HttpClient);
  private readonly environment = inject(ENVIRONMENT);
  private readonly API_URL = `${this.environment.origin.monolith}/Conversations`;

  getDiscussion(discussionId: string) {
    return this.http.get<DiscussionModel>(`${this.API_URL}/${discussionId}`);
  }

  attachDiscussionTodoStats(discussion: DiscussionModel): Observable<DiscussionModel> {
    const { holdingMeeting, isManageeDone, isManagerDone, canEvaluateManager, canEvaluateSelf } = discussion;

    if (!holdingMeeting) return of(discussion);
    if (isManagerDone) return of(discussion);
    if (isManageeDone && (canEvaluateManager || canEvaluateSelf)) return of(discussion);
    if (!discussion.periodStartDate || !discussion.periodEndDate) return of(discussion);

    const params = new HttpParams()
      .set('startDate', discussion.periodStartDate.toString())
      .set('endDate', discussion.periodEndDate.toString());

    return this.http
      .get<DiscussionTodoStats>(
        `${this.environment.origin.monolith}/ToDos/TodosStatsForConversation/${discussion._id}`,
        { params }
      )
      .pipe(map(todoStats => ({ ...discussion, todoStats })));
  }

  saveForm(discussionId: string, dto: SaveDiscussionFormDto) {
    return this.http.put<void>(`${this.API_URL}/${discussionId}`, dto);
  }

  createDiscussion(request: DiscussionCreateRequest): Observable<DiscussionModel[]> {
    return this.http.post<DiscussionModel[]>(this.API_URL, request);
  }

  patchDiscussion(discussionId: string, update: PatchDiscussionDto) {
    return this.http.patch<void>(`${this.API_URL}/${discussionId}`, update);
  }
}
